export const width100PCT = () => ({
  width: "100%",
});
